import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  useDebatesStatusStore,
  useSubworkspaceStore,
} from "../../Context/store";
import { hoverSidebarStyle } from "../../Utils/Constant";

const ForumsFeedbar = ({ pathname }) => {
  const [open, setOpen] = useState(0);
  const { subWorkspaceList } = useSubworkspaceStore();
  const navigate = useNavigate();

  const { allForumStatus } = useDebatesStatusStore();

  useEffect(() => {
    const path = pathname.slice(1).split("/")[0];
    if (path === "debated") {
      setOpen("debated");
    } else if (path === "voted") {
      setOpen("voted");
    } else if (path === "private") {
      setOpen("private");
    } else if (path === "messageOption") {
      setOpen("message");
    } else if (path === "debated-public") {
      setOpen("public-debated");
    } else if (path === "voted-public") {
      setOpen("public-voted");
    } else {
      setOpen(0);
    }
  }, [pathname]);

  return (
    <div className={`flex ${subWorkspaceList?.length > 2 ? "h-40" : "h-20"} overflow-auto flex-col gap-2 px-2 w-full`}>
      {" "}
      {subWorkspaceList?.map((subWorkspace) => (
        <div
          key={subWorkspace?.subWorkSpaceId}
          onClick={(e) => {
            e.stopPropagation();
            navigate(`feed/${subWorkspace?.subWorkSpaceId}`);
          }}
          className={`w-full border-b-0 px-2 py-2 text-md rounded-md ${hoverSidebarStyle} hover:cursor-pointer hover:text-debatePalette-background hover:font-bold ${
            open === subWorkspace?.subWorkSpaceId ||
            pathname === `/feed/${subWorkspace?.subWorkSpaceId}`
              ? `font-bold text-debatePalette-background bg-primary`
              : `text-debatePalette-hr font-semibold`
          }`}
        >
          <div className={`flex gap-2 items-center justify-between`}>
            <span>{subWorkspace?.subWorkSpaceName}</span>
            {allForumStatus?.forums?.[subWorkspace?.subWorkSpaceId]?.sections?.semiPublicFeed && (
              <div className="inline-block size-2 rounded-full bg-primary"></div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ForumsFeedbar;

//       <div
//   key={subWorkspace?.subWorkSpaceId}
//   onClick={() => handleForumSelect(subWorkspace)}
//   className="px-4 flex justify-between items-center"
// >
//   <div className="py-2 rounded-none text-small truncate text-ellipsis scrollbar-hide font-semibold text-debatePalette-background ">
//     {subWorkspace?.subWorkSpaceName}
//   </div>
// </div>
